import { useSyncExternalStore } from "react";

/**
 * Algolia 장애 상태.
 *
 * 커넥터가 인덱스 설정(replica / attributesForFaceting)을 덮어쓰면 정렬 인덱스가 사라져 404 가 나고
 * 화면이 비어 버린다. 한 번이라도 실패하면 세션 동안 Shopify 쿼리로 되돌려 매장이 멈추지 않게 한다.
 *
 * 앱마다 zustand 버전이 달라(tune 5 / thisisneverthat 4) 공용 패키지에서는 React 의
 * useSyncExternalStore 로 직접 구현한다. 값이 true 로 한 번 바뀌면 되돌리지 않는다.
 */

let isDown = false;
const listeners = new Set<() => void>();

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

function getSnapshot() {
  return isDown;
}

/** 요청 실패를 기록한다. 이후 useIsAlgoliaDown() 을 쓰는 화면이 Shopify 쿼리로 전환된다. */
export function markAlgoliaDown(reason: string) {
  if (isDown) return;

  // eslint-disable-next-line no-console
  console.warn("[ALGOLIA] 요청 실패로 Shopify 쿼리로 전환합니다.", reason);
  isDown = true;
  listeners.forEach((listener) => {
    listener();
  });
}

/** Algolia 요청이 실패한 적이 있는지 */
export function useIsAlgoliaDown(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot);
}
